import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Biography from './components/Biography';
import ArtisticCareer from './components/ArtisticCareer';
import Awards from './components/Awards';
import Videos from './components/Videos';
import Timeline from './components/Timeline';
import Gallery from './components/Gallery';
import Articles from './components/Articles';
import Quotes from './components/Quotes';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Biography />
      <ArtisticCareer />
      <Awards />
      <Videos />
      <Timeline />
      <Gallery />
      <Articles />
      <Quotes />
      <Footer />
    </div>
  );
}

export default App;
